import { render, staticRenderFns } from "./InstagramWidget.vue?vue&type=template&id=39ed3950&scoped=true"
import script from "./InstagramWidget.vue?vue&type=script&lang=js"
export * from "./InstagramWidget.vue?vue&type=script&lang=js"
import style0 from "./InstagramWidget.vue?vue&type=style&index=0&id=39ed3950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ed3950",
  null
  
)

export default component.exports